// tslint:disable
export var PharmacyCoverageType;
(function (PharmacyCoverageType) {
    // RTL
    PharmacyCoverageType[PharmacyCoverageType["RTL"] = 1] = "RTL";
    // MOD
    PharmacyCoverageType[PharmacyCoverageType["MOD"] = 2] = "MOD";
    // LTC
    PharmacyCoverageType[PharmacyCoverageType["LTC"] = 3] = "LTC";
    // Specialty
    PharmacyCoverageType[PharmacyCoverageType["Specialty"] = 4] = "Specialty";
})(PharmacyCoverageType || (PharmacyCoverageType = {}));
PharmacyCoverageType['SPECIALTY'] = 4;
//# sourceMappingURL=PharmacyCoverageType.js.map